/**
 * The single declared home for who appears in the product roster, and under
 * what name the onboarding intake agent is deployed.
 *
 * Both the CLI (which deploys agents and stamps this metadata) and the web app
 * (which reads it) import from here. They previously each held their own copy:
 * the intake name was declared twice and drifted through a rename, and the
 * public-agent allowlist lived in the HOSTED deploy path while the agents it
 * names are PROMPT agents that never travel that path — so the allowlist
 * guarded a road its only two subjects never took, and every install shipped
 * an empty roster. Keep this the only definition of both facts.
 */

export type ProductVisibility = "public" | "internal";

/** Deployed by `m8t bootstrap ui` for the onboarding conversation, then retired.
 *  Deliberately NOT in PUBLIC_PRODUCT_AGENTS — see productVisibilityFor. */
export const INTAKE_AGENT_NAME = "azzy-intake";

/** The agents that belong in the product roster. Everything else is internal. */
export const PUBLIC_PRODUCT_AGENTS: ReadonlySet<string> = new Set(["stacey", "azzy"]);

/**
 * Decide the `productVisibility` metadata stamp for an agent being deployed.
 *
 * Fails closed: anything not explicitly allow-listed is `internal`, which
 * matches how the web derives visibility from metadata. An unknown or renamed
 * worker stays out of the product roster rather than leaking into it.
 */
export function productVisibilityFor(agentName: string): ProductVisibility {
  return PUBLIC_PRODUCT_AGENTS.has(agentName) ? "public" : "internal";
}
